import Component from './Users';

export default Component;
